import { Block } from '@comp/crRender'
import {
    BasicInformation,
    Accreditations,
    AdvancedTechnologies,
    Specialties,
    Testimonials,
    RefundPolicy,
    Gallery,
    VideoSection,
    ContactInformation,
    TopRatedDoctors
} from './sections'
import PaymentTerms from './sections/PaymentTerms'

const Details = ({ requestDetails }) => {


    return (
        <Block isRender={true} className="hospital-profile-container">

            {/* Main Content Grid */}
            <div className="hospital-profile-grid">
                {/* Left Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <BasicInformation requestDetails={requestDetails} />

                    <Accreditations accredations={requestDetails?.accredations || []} />

                    <AdvancedTechnologies technologies={requestDetails?.technologies || []} />
                    {/* Gallery and Video in same row */}
                    <div className="media-row">
                        <Gallery srcLink={window.WEB_LINK} galleryImages={requestDetails?.files || []} />
                        <VideoSection videoUrl={requestDetails?.videoUrl || "  "} />
                    </div>

                    <Testimonials testimonials={requestDetails?.reviews} />

                    <PaymentTerms paymentTerms={requestDetails?.paymentTerms } />
                    <RefundPolicy refundPolicy={requestDetails?.refundPolicy } />

                </div>

                {/* Right Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <ContactInformation requestDetails={requestDetails} />
                    <TopRatedDoctors topDoctors={requestDetails?.doctors ||[]  } />
                    <Specialties serviceCategories={requestDetails?.serviceCategories ||[]  }/>
                </div>
            </div>
        </Block>
    )
}

export default Details
